import type { FunctionComponent } from "react";
import { payments0 } from "@/data/PaymentHub.ts";
import { getPaymentIcon } from "@/react/PaymentSettingView/PaymentMap.ts";

interface SearchPaymentMethodProps {
  onClose?: () => void
}

const SearchPaymentMethod: FunctionComponent<SearchPaymentMethodProps> = ({onClose}) => {
  return (
    <div className="w-[524px] h-auto font-mulish overflow-hidden rounded-[8px] bg-white">
      <div className="flex flex-1  px-3 py-2 rounded-t-[8px] border-b border-[#e0e0e0]">
        <div className="flex-1 font-bold text-[16px] text-[#0051c1]">
          Search Payment Method
        </div>
        <img src="/icon-close-popup-icon--grey@2x.png" className="w-[22px] h-[22px]" alt="" onClick={onClose}/>
      </div>
      <div className="flex flex-wrap gap-2 p-3">
        {payments0().map(payment => (
          <div key={payment._id} className="p-2 gap-[6px] border flex rounded-[4px] w-[160px]" style={{ borderColor: "#bcbcbc" || "#90caf9", backgroundColor: "#e3f2fd" }}>
            <img src={getPaymentIcon(payment.icon)} className="w-6" alt=""/>
            <span className="font-semibold text-[14px]">{payment.name}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SearchPaymentMethod;